import React, { useState, useEffect, useRef } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { fetchWithDefaults } from '../../../../config/fetchDefault';
import Icon from '../../../../assets/icons/icon';
import { fileServer } from '../../../../config/commUrls';
import { updateSpecificLead } from '../../../../features/queueSlice';

function AttachFile({leadId,files}) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [filesAttached, setFilesAttached] = useState([]);
    const [previewUrl, setPreviewUrl] = useState(null);
    const fileInputRef = useRef(null);

    const dispatch = useDispatch();

    const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };
    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (file) {
            if (isValidFile(file)) {
                setSelectedFile(file);
                previewFile(file);
            } else {
                alert("Invalid file type or size. Please select a valid file.");
            }
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const isValidFile = (file) => {
        const allowedTypes = ["application/pdf", "text/csv", "application/vnd.ms-excel", "image/png", "image/jpeg"];
        const maxSize = 20 * 1024 * 1024; // 20 MB

        // Check if the file type and size are valid
        return allowedTypes.includes(file.type) && file.size <= maxSize;
    };

    const handleFileChange = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (file) {
            if (isValidFile(file)) {
                setSelectedFile(file);
                previewFile(file);
            } else {
                alert("Invalid file type or size. Please select a valid file.");
            }
        }
    };

    const handleSubmit = async () => {
        if (selectedFile) {
            const formData = new FormData();
            const csrfToken = await localStorage.getItem('keepMeAlive');
                // Append the selected file to the FormData object
            formData.append('file', selectedFile);
            let defaultHeaders = {
                'X-CSRF-Token': csrfToken,
            };
            const headers = { ...defaultHeaders };
            try {
                const response = await fetch(`${process.env.REACT_APP_FUNNEL_HOSTNAME}:${process.env.REACT_APP_BACKEND_PORT}/attachFileToLead?lead=${leadId}`, {
                    method: 'POST',
                    body: formData,
                    headers : headers
                });
                const jsonData = await response.json();
                setFilesAttached(prevFilesAttached => [...prevFilesAttached, ...jsonData]);
                const file = jsonData[0]?.file;
                if(file){
                const fileName = file.slice(0,file.lastIndexOf('.'));
                const filesList = files.split(',');
                filesList.push(fileName);
                const payload = {
                    id: leadId,
                    field: 'file_link',
                    value: filesList.join(','),
                }
                dispatch(updateSpecificLead(payload));
                setSelectedFile(null);
                }
            } catch (error) {
                console.error('Error:', error.message);
                // Handle error, if needed
            }
        } else {
            console.log("No file selected");
        }
    };

    const previewFile = (file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            setPreviewUrl(reader.result);
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };

    const handleOpenFileDialog = () => {
        fileInputRef.current.click();
    };

    const handleRemoveFile = (e) => {
        e.stopPropagation();
        setSelectedFile(null);
        setPreviewUrl(null);
    };
    const gatherFiles=async()=>{
        const response = await fetchWithDefaults(`/gatherFiles?files=${btoa(files)}`);

        if (!response.ok) {
            console.log('Network response was not ok');
        }
        const jsonData = await response.json();
        const myArray = jsonData.map(item => ({
            name: item.name,
            file: item.id+'.'+item.ext,
            fileId: item.id,
        }));
        setFilesAttached(myArray);
    }
    useEffect(() => {
        if(files && files.includes(',') > 0){
            gatherFiles();
        }
        else{
            setFilesAttached([]);
        }
    }, []);

    const handleDeleteFile = async (fileId, fileName) => {

        try {
            const response = await fetchWithDefaults(`/deleteFileFromLead`, {
                method: 'DELETE',
                body: JSON.stringify({ fileId, leadId }),
            });

            const result = await response.json();
             console.log("Delete response:", result);

            if (result.status) {
                setFilesAttached(prev => prev.filter(file => file.fileId !== fileId));

                const updatedFiles = files
                    .split(',')
                    .filter(name => name !== fileName);

                dispatch(updateSpecificLead({
                    id: leadId,
                    field: 'file_link',
                    value: updatedFiles.join(','),
                }));
                resetFileInput();
            } else {
                alert('Error deleting file');
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert('Failed to delete file');
        }
    }

    return (
        <div className="completeAttachWrapper" style={{height: '100%'}}>
              {Array.isArray(filesAttached) && filesAttached.length > 0 && (
                filesAttached.map((file, index) => {
                    const fileName = file.file?.slice(0, file.file.lastIndexOf('.'));
                    return(
                    <div key={index} className='attachedFile' style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between', gap: '8px' }} >
                        <a href={`${fileServer}/files/${file.file}`} target="_blank" style={{color: '#ffffff',textDecoration: 'none',fontWeight: '700'}}>{file.name}</a>
                        <span onClick={() => handleDeleteFile(file.fileId, fileName)} style={{ cursor: 'pointer', marginRight:'20px', marginBottom: '-15px' }}>
                          <Icon name={'x-circle-q'} size={20} height={28} adjust="fontello" />
                        </span>
                    </div>
                )})
            )}

            <div className="attachFileDropZone" onDrop={handleDrop} onDragOver={handleDragOver} onClick={handleOpenFileDialog}>
                <div className="attachFileText">Drag & Drop File Or Click Here</div>
                <div className="attachFileSubText">(.pdf, .csv, .xls, .png, .jpeg)</div>
                <input type="file" onChange={handleFileChange} style={{ display: "none" }} ref={fileInputRef} />
                {selectedFile && (
                    <div>
                        {selectedFile.type.startsWith("image/") ? (
                            <div className="preview" style={{ position: 'relative' }}>
                                <img src={previewUrl} alt="Preview" style={{ maxWidth: "50px", maxHeight: "50px" }} />
                                <span className="fileText">Selected File: {selectedFile.name}<span className="removeIcon" onClick={handleRemoveFile}><span className="fontello" style={{marginTop: '-7px'}}><Icon name={'x-circle-q'} size={24} className="closeIcon" adjust="fontello" /></span></span></span>

                            </div>
                        ) : (
                            <div className="preview" style={{ position: 'relative' }}><span className="fileText">Selected File: {selectedFile.name} <span className="removeIcon" onClick={handleRemoveFile} ><span className="fontello" style={{marginTop: '-7px'}}><Icon name={'x-circle-q'} size={24} className="closeIcon" adjust="fontello" /></span></span></span></div>
                        )}

                    <button className="accentButton" style={{ lineHeight: '25px' }} onClick={(e) => { e.stopPropagation(); handleSubmit(); }}>Upload</button>
                    </div>

                )}
            </div>
        </div>
    );
}

export default AttachFile;
